module.exports = __webpack_public_path__ + "img/icon_human_black.407d41c8.svg";